import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import moment from 'moment'
import {
  $DCprimaryColor,
  DcFlexBox,
  DcTag,
  PixelCurrency,
  PixelFactoryContext,
  PixelLeftPanel,
  PixelModal,
  PixelPageContainer,
  PixelRightPanel,
  PixelSpinner,
  PixelText,
  Section,
  SectionContent,
  colors,
} from 'pixel-base'
import { env } from 'shared/env'
import styled from 'styled-components'

import {
  addNewInvoice,
  getBankAccounts,
  getCustomerPaymentMethods,
  getInvoiceDetail,
  getInvoicesMeta,
} from 'utils/api-routes.util'

import ActionMenu from './InvoiceDetailsComponents/ActionMenu'
import Email from './InvoiceDetailsComponents/Email'
import LineItems from './InvoiceDetailsComponents/LineItems'
import PaymentRecord from './InvoiceDetailsComponents/PaymentRecord'
import PayViaStripe from './InvoiceDetailsComponents/PayViaStripe'
import ViewPaymentHistory from './InvoiceDetailsComponents/ViewPaymentHistory'
import InvoiceInfo from './InvoiceInfo'
import { IPixelFactory } from '../../../../../decl'
import AddDiscount from '../../../orders/OrderDetails/components/AddDiscount'
import Consignment from '../../../orders/OrderDetails/components/Consignment'
import CustomerInformation from '../../../orders/OrderDetails/components/CustomerInformation'
import OrderShipping from '../../../orders/OrderDetails/components/OrderShipping'

const filterDummy = (d) => d.product_id !== -1

const filterDeleted = (d) => !d.is_deleted

interface IUpdateInvoiceStatus {
  invoice_payment_status: string
  invoice_status: string
  invoice_payment_received: number | string
  invoice_balance_amount: number | string
}

const InvoiceDetails = (props) => {
  const { invoiceId, setInvoiceId } = props

  const navigate = useNavigate()
  const { showFailure, showSuccess, showPageLoader, hidePageLoader } =
    React.useContext<IPixelFactory>(PixelFactoryContext)
  const chartsRef = React.useRef(null)

  const [invoiceMeta, setInvoiceMeta] = React.useState<any>({})
  const [customerData, setCustomerData] = React.useState<any>({})
  const [invoiceBalance, setInvoiceBalance] = React.useState<any>(0)
  const [showEmailPopup, setShowEmailPopup] = React.useState(false)
  const [showPaymentModel, setShowPaymentModel] = React.useState(false)
  const [saveLineItems, setSaveLineItems] = React.useState('')
  const [options, setOptions] = React.useState([])
  const [bank, setBank] = React.useState([])
  const [isCustomerAdded, setIsCustomerAdded] = React.useState(false)
  const [PaymentURL, setPaymentURL] = React.useState()
  const [safepayPaymentURL, setSafepayPaymentURL] = React.useState()
  const [isHovered, setIsHovered] = useState(false)
  const [showStripePaymentModel, setShowStripePaymentModel] =
    React.useState(false)
  const [isShowSpinner, setIsShowSpinner] = React.useState(false)

  const [showPaymentHistoryModel, setShowPaymentHistoryModel] =
    React.useState(false)

  const [invoiceData, setInvoiceData] = React.useState<any>({
    invoice_payment_status: '',
    invoice_status: '',
    invoice_sent: '',
    invoice_id: null,
    invoice_payment_received: '',
    invoice_balance_amount: '',
  })

  const [newInvoiceData, setNewInvoiceData] = React.useState<any>({
    due_date: moment().format('YYYY-MM-DD'),
    reference_number: '',
    payment_lines: [],
    shipping_lines: [],
    discounts: [],
    customer: {
      customer_id: null,
      first_name: null,
      last_name: null,
      email: null,
      phone: null,
      company: null,
      balance: null,
    },
    billing: {
      address_id: null,
      address1: null,
      city: null,
      country: null,
      country_code: null,
      email: null,
      first_name: null,
      last_name: null,
      phone: null,
      postcode: null,
      zip: '',
      state_name: null,
      state_code: null,
    },
    is_billing_address_same: true,
    shipping: {
      address_id: null,
      address1: null,
      city: null,
      country: null,
      country_code: null,
      email: null,
      first_name: null,
      last_name: null,
      phone: null,
      postcode: null,
      zip: '',
      state_name: null,
      state_code: null,
    },
    customer_id: '',
    total: 0,
    email: '',
    shipping_address_id: null,
    billing_address_id: null,
    invoice_date: moment().format('DD-MM-YYYY'),
    line_items: [],
    total_tax: 0,
  })

  const fetchInvoiceDetail = () => {
    setIsShowSpinner(true)
    getInvoiceDetail(invoiceId).subscribe((res: any) => {
      setIsShowSpinner(false)
      setInvoiceData(res.response?.data ? res.response.data : [])

      if (res.response.data?.customer) {
        setCustomerData({
          ...res.response.data?.customer,
          billing: res.response.data?.billing_address,
          shipping: res.response.data?.customer,
        })
      }
      if (res.response.data && !PaymentURL) {
        setPaymentURL(res.response?.data?.payments_url)
      }
      if (res?.response?.data && !safepayPaymentURL) {
        setSafepayPaymentURL(res.response?.data?.safepay_payments_url)
      }
      if (res.response?._meta) {
        setInvoiceMeta(res.response._meta)
      }
    })
  }
  const fetchInvoiceMeta = () => {
    getInvoicesMeta().subscribe(() => {
      setNewInvoiceData({
        ...newInvoiceData,
      })
    })
  }

  const baseURL = env.SERVER_ADDR
  const handleAddNewInvoice = (action) => {
    showPageLoader()
    const data = { ...newInvoiceData }
    data.line_items = data.line_items.filter(filterDeleted).filter(filterDummy)
    addNewInvoice(data).subscribe((res: any) => {
      hidePageLoader()
      if (res.response) {
        if (action === 'print') {
          const { token } = JSON.parse(
            localStorage.getItem('user_info') || '{token: null}',
          )
          const link = `${baseURL}api/v2/print/invoice/${token}/${res.response?.invoice_id}`
          window.open(link, '_blank')
          navigate(`/invoice/detail/${res.response?.invoice_id}`)
        } else if (action === 'newInvoice') {
          showSuccess('Added successfully')
          navigate(`/invoice/detail/${res.response?.invoice_id}`)
        }
      } else {
        showFailure(`${res.response.field} is required`)
      }
    })
  }

  const getData = () => {
    return invoiceId === 'new'
      ? [
          ...((newInvoiceData?.tempLineItems
            ? newInvoiceData.tempLineItems
            : newInvoiceData.line_items
          )
            ?.filter(filterDeleted)
            .filter(filterDummy) || []),
        ]
      : [
          ...((invoiceData?.tempLineItems
            ? invoiceData.tempLineItems
            : invoiceData.line_items
          )
            ?.filter(filterDeleted)
            .filter(filterDummy) || []),
        ]
  }

  const getNewInvoiceTotal = () => {
    const grandTotal = [...getData()].reduce((acc, item) => {
      const total = item.is_deleted ? 0 : Number(item.total)
      return Number(acc) + total
    }, 0)
    const shipping = newInvoiceData.shipping_lines?.reduce((acc, cur) => {
      return acc + Number(cur.total)
    }, 0)
    const fixedDiscount = newInvoiceData.discounts?.reduce((acc, cur) => {
      return cur.discount_code === 'fixed_amount'
        ? acc + Number(cur.amount)
        : acc
    }, 0)
    const percentageDiscount = newInvoiceData.discounts?.reduce((acc, cur) => {
      return cur.discount_code === 'percentage' ? acc + Number(cur.amount) : acc
    }, 0)
    let pdiscount = 0
    if (percentageDiscount <= 100) {
      pdiscount = (grandTotal * percentageDiscount) / 100
    }

    return (
      (grandTotal || 0) +
      (shipping || 0) -
      (fixedDiscount || 0) -
      (pdiscount || 0) +
      (getInvoiceTotalTax() || 0)
    )
  }
  const getExistingInvoiceTotal = () => {
    const grandTotal = [...getData()].reduce((acc, item) => {
      const total = item.is_deleted ? 0 : Number(item.total)
      return Number(acc) + total
    }, 0)
    const shipping = invoiceData.order_shipping?.reduce((acc, cur) => {
      return acc + Number(cur.total)
    }, 0)
    const fixedDiscount = invoiceData.discount_lines?.reduce((acc, cur) => {
      return cur.discount_code === 'fixed_amount'
        ? acc + Number(cur.amount)
        : acc
    }, 0)

    const percentageDiscount = invoiceData.discount_lines?.reduce(
      (acc, cur) => {
        return cur.discount_code === 'percentage'
          ? acc + Number(cur.amount)
          : acc
      },
      0,
    )
    let pdiscount = 0
    if (percentageDiscount <= 100) {
      pdiscount = (grandTotal * percentageDiscount) / 100
    }
    return (
      (grandTotal || 0) +
      (shipping || 0) -
      (fixedDiscount || 0) -
      (pdiscount || 0) +
      (getInvoiceTotalTax() || 0)
    )
  }
  const getInvoiceTotalTax = () => {
    return [...getData()].reduce((acc, item) => {
      const tax = item.is_deleted ? 0 : Number(item.tax)
      return Number(acc) + tax
    }, 0)
  }

  const getPaymentURL = (URL) => {
    setPaymentURL(URL)
  }

  const getPaymentSafepayURL = (URL) => {
    setSafepayPaymentURL(URL)
  }

  const getInvoiceTotal = () => {
    return invoiceId === 'new'
      ? getNewInvoiceTotal()
      : getExistingInvoiceTotal()
  }

  const getMethods = () => {
    getCustomerPaymentMethods().subscribe((res: any) => {
      setOptions(res.response?.data || [])
    })
  }

  const getBank = () => {
    getBankAccounts().subscribe((res: any) => {
      setBank(res.response?.data || [])
    })
  }

  const handleMouseEnter = () => {
    setIsHovered(true)
  }

  const handleMouseLeave = () => {
    setIsHovered(false)
  }

  React.useEffect(() => {
    setInvoiceBalance(invoiceData?.invoice_balance_amount)
  }, [invoiceData])

  React.useEffect(() => {
    getMethods()
    getBank()
  }, [])

  React.useEffect(() => {
    if (invoiceId == 'new') {
      setInvoiceData([])
      setCustomerData({})
    } else {
      fetchInvoiceDetail()
      fetchInvoiceMeta()
    }
  }, [invoiceId])

  return (
    <>
      <PixelSpinner isShow={isShowSpinner} />

      <PixelPageContainer>
        <DcFlexBox
          ref={chartsRef}
          flexDirection="column"
          justifyContent="center"
          width="100%"
          margin="0 auto"
          height="auto"
          style={{
            transition: ' all 0.3s ease-in-out',
          }}
        >
          <DcFlexBox
            style={{ backgroundColor: colors.white }}
            padding="0.5rem 0.5rem"
            width="100%"
            height="auto"
          >
            <PixelLeftPanel justifyContent="flex-start" width={'40%'}>
              <DcFlexBox>
                <PixelText
                  textSize="16px"
                  variant="dark"
                  style={{ fontWeight: '600', paddingRight: '5px' }}
                >
                  Invoice # {invoiceData.source_order_id}
                </PixelText>

                <DcTag
                  textColor={
                    invoiceData.invoice_payment_status === 'paid'
                      ? colors.warning
                      : colors.danger
                  }
                  customBackgroundColor={
                    invoiceData.invoice_payment_status === 'paid'
                      ? colors.warningLight
                      : colors.dangerLight
                  }
                >
                  {invoiceData.invoice_payment_status}
                </DcTag>
              </DcFlexBox>
            </PixelLeftPanel>
            <PixelRightPanel
              justifyContent="flex-end"
              alignItems="flex-end"
              gap="10px"
            >
              <ActionMenu
                invoiceId={invoiceId}
                newInvoiceData={newInvoiceData}
                invoiceData={invoiceData}
                invoiceMeta={invoiceMeta}
                setInvoiceData={setInvoiceData}
                setSaveLineItems={setSaveLineItems}
                setShowEmailPopup={setShowEmailPopup}
                setShowPaymentModel={setShowPaymentModel}
                setShowStripePaymentModel={setShowStripePaymentModel}
                setShowPaymentHistoryModel={setShowPaymentHistoryModel}
                handleAddNewInvoice={handleAddNewInvoice}
                isCustomerAdded={isCustomerAdded}
                customerId={customerData.customer_id}
                getPaymentURL={getPaymentURL}
                getPaymentSafepayURL={getPaymentSafepayURL}
                setInvoiceId={setInvoiceId}
              />
            </PixelRightPanel>
          </DcFlexBox>
          <DcFlexBox padding="20px 12px 20px 12px" width="100%" height="auto">
            <PixelLeftPanel
              flexDirection="column"
              justifyContent="flex-start"
              width="65%"
              gap="18px"
            >
              <Section noPadding>
                <SectionContent noPadding>
                  <LineItems
                    detailID={invoiceData.invoice_id}
                    saveLineItems={saveLineItems}
                    setSaveLineItems={setSaveLineItems}
                    setDetails={
                      invoiceId === 'new' ? setNewInvoiceData : setInvoiceData
                    }
                    details={invoiceId === 'new' ? newInvoiceData : invoiceData}
                    newInvoice={invoiceId === 'new'}
                  />
                </SectionContent>
              </Section>

              <Section noPadding>
                <SectionContent noPadding>
                  <AddDiscount
                    detailID={invoiceData.invoice_id}
                    setDetails={setInvoiceData}
                    details={invoiceData}
                    newOrder={invoiceId === 'new'}
                    isItInvoice={true}
                    newInvoice={invoiceId === 'new'}
                    newOrderData={newInvoiceData}
                    setNewOrderData={setNewInvoiceData}
                  />
                </SectionContent>
              </Section>

              <Section noPadding>
                <SectionContent noPadding>
                  <OrderShipping
                    detailID={invoiceData.invoice_id}
                    setDetails={setInvoiceData}
                    details={invoiceData}
                    isItInvoice={true}
                    newOrder={invoiceId === 'new'}
                    newOrderData={newInvoiceData}
                    setNewOrderData={setNewInvoiceData}
                  />
                </SectionContent>
              </Section>

              <Section noPadding>
                <SectionContent noPadding>
                  <InnerSection>
                    <PixelText
                      style={{
                        fontWeight: '600',
                        color: 'rgba(0, 0, 0, 0.84)',
                      }}
                    >
                      Invoice Summary
                    </PixelText>
                  </InnerSection>
                  <InnerSection>
                    <DcFlexBox alignItems={'flex-end'} flexDirection={'column'}>
                      <PixelText style={{ fontSize: '12px' }}>
                        Tax:
                        <strong>
                          <PixelCurrency value={getInvoiceTotalTax()} />
                        </strong>
                      </PixelText>
                      <PixelText style={{ fontSize: '12px' }}>
                        Total:
                        <strong>
                          <PixelCurrency value={getInvoiceTotal()} />
                        </strong>
                      </PixelText>
                      <PixelText style={{ fontSize: '12px' }}>
                        Amount Paid:
                        <strong>
                          <PixelCurrency
                            value={invoiceData.invoice_payment_received || 0.0}
                          />
                        </strong>
                      </PixelText>
                      <PixelText style={{ fontSize: '12px' }}>
                        Balance Due:
                        <strong>
                          <PixelCurrency value={invoiceBalance || 0.0} />
                        </strong>
                      </PixelText>
                    </DcFlexBox>
                  </InnerSection>
                </SectionContent>
              </Section>
              {PaymentURL && (
                <Section noPadding>
                  <SectionContent noPadding>
                    <InnerSection
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        padding: '5px , 10px, 5px,10px',
                        flexDirection: 'row',
                      }}
                    >
                      <PixelText
                        style={{
                          fontWeight: '600',
                          color: 'rgba(0, 0, 0, 0.84)',
                        }}
                      >
                        Stripe Payment Link
                      </PixelText>
                      <PixelText
                        style={{
                          fontWeight: '600',
                          color: 'rgba(0, 0, 0, 0.84)',
                        }}
                      >
                        <a
                          style={{
                            textDecoration: isHovered ? 'underline' : 'none',
                            color: $DCprimaryColor,
                          }}
                          onMouseEnter={handleMouseEnter}
                          onMouseLeave={handleMouseLeave}
                          href={PaymentURL}
                          target="_blank"
                          rel="noreferrer"
                        >
                          Pay Invoice
                        </a>
                      </PixelText>
                    </InnerSection>
                  </SectionContent>
                </Section>
              )}

              {safepayPaymentURL && (
                <Section noPadding>
                  <SectionContent noPadding>
                    <InnerSection
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        padding: '5px , 10px, 5px,10px',
                        flexDirection: 'row',
                      }}
                    >
                      <PixelText
                        style={{
                          fontWeight: '600',
                          color: 'rgba(0, 0, 0, 0.84)',
                        }}
                      >
                        Safepay Payment Link
                      </PixelText>
                      <PixelText
                        style={{
                          fontWeight: '600',
                          color: 'rgba(0, 0, 0, 0.84)',
                        }}
                      >
                        <a
                          style={{
                            textDecoration: isHovered ? 'underline' : 'none',
                            color: $DCprimaryColor,
                          }}
                          onMouseEnter={handleMouseEnter}
                          onMouseLeave={handleMouseLeave}
                          href={safepayPaymentURL}
                          target="_blank"
                          rel="noreferrer"
                        >
                          Pay Invoice
                        </a>
                      </PixelText>
                    </InnerSection>
                  </SectionContent>
                </Section>
              )}
            </PixelLeftPanel>
            <PixelRightPanel
              flexDirection="column"
              justifyContent="flex-start"
              width="35%"
              gap="18px"
            >
              <Section noPadding>
                <SectionContent noPadding>
                  <InvoiceInfo
                    detailID={invoiceData.invoice_id}
                    setDetails={setInvoiceData}
                    details={invoiceData}
                    newOrder={invoiceId === 'new'}
                    newOrderData={newInvoiceData}
                    setNewOrderData={setNewInvoiceData}
                  />
                </SectionContent>
              </Section>
              <Section noPadding>
                <SectionContent noPadding>
                  <CustomerInformation
                    detailID={invoiceData.invoice_id}
                    setDetails={
                      invoiceId === 'new' ? setNewInvoiceData : setInvoiceData
                    }
                    details={invoiceId === 'new' ? newInvoiceData : invoiceData}
                    newOrder={invoiceId === 'new'}
                    invoiceNew={invoiceId === 'new'}
                    isItInvoice={true}
                    newOrderData={newInvoiceData}
                    setNewOrderData={setNewInvoiceData}
                    customerData={customerData}
                    setCustomerData={setCustomerData}
                    setIsCustomerAdded={setIsCustomerAdded}
                  />
                </SectionContent>
              </Section>
              {invoiceId !== 'new' && (
                <Section noPadding>
                  <SectionContent noPadding>
                    <Consignment
                      setReload={fetchInvoiceDetail}
                      detailID={invoiceId}
                      setDetails={setInvoiceData}
                      order={invoiceData}
                    />
                  </SectionContent>
                </Section>
              )}
            </PixelRightPanel>
          </DcFlexBox>
        </DcFlexBox>
      </PixelPageContainer>
      {showEmailPopup && (
        <PixelModal
          title={'Send Email'}
          handleClose={() => setShowEmailPopup(false)}
          show={showEmailPopup}
        >
          {showEmailPopup && (
            <Email
              customerData={customerData}
              invoiceData={invoiceData}
              invoiceId={invoiceId}
              handleClose={() => setShowEmailPopup(false)}
            />
          )}
        </PixelModal>
      )}
      {showPaymentModel && (
        <PixelModal
          title={'Record Payment'}
          handleClose={() => setShowPaymentModel(false)}
          show={showPaymentModel}
        >
          {showPaymentModel && (
            <PaymentRecord
              customerData={customerData}
              invoiceData={invoiceData}
              invoiceId={invoiceId}
              options={options}
              bank={bank}
              handleClose={(data: IUpdateInvoiceStatus) => {
                if (data) {
                  setInvoiceData(() => ({
                    ...invoiceData,
                    invoice_payment_status: data?.invoice_payment_status,
                    invoice_status: data?.invoice_status,
                    invoice_payment_received: data?.invoice_payment_received,
                    invoice_balance_amount: data?.invoice_balance_amount,
                  }))
                }
                setShowPaymentModel(false)
              }}
            />
          )}
        </PixelModal>
      )}
      {showStripePaymentModel && (
        <PixelModal
          title={'Pay Via Stripe'}
          handleClose={() => setShowStripePaymentModel(false)}
          show={showStripePaymentModel}
        >
          {showStripePaymentModel && (
            <PayViaStripe
              customerData={customerData}
              invoiceData={invoiceData}
              invoiceId={invoiceId}
              handleClose={(data: IUpdateInvoiceStatus) => {
                if (data) {
                  setInvoiceData(() => ({
                    ...invoiceData,
                    invoice_payment_status: data?.invoice_payment_status,
                    invoice_status: data?.invoice_status,
                    invoice_payment_received: data?.invoice_payment_received,
                    invoice_balance_amount: data?.invoice_balance_amount,
                  }))
                }
                setShowStripePaymentModel(false)
              }}
            />
          )}
        </PixelModal>
      )}

      {showPaymentHistoryModel && (
        <PixelModal
          title={'Customer Payment History'}
          handleClose={() => setShowPaymentHistoryModel(false)}
          show={showPaymentHistoryModel}
          size={{
            minWidth: '60vw',
            maxheight: '90vh',
          }}
        >
          {showPaymentHistoryModel && (
            <ViewPaymentHistory
              invoice_id={invoiceData.invoice_id}
              handleClose={() => {
                setShowPaymentHistoryModel(false)
              }}
            />
          )}
        </PixelModal>
      )}
    </>
  )
}

const InnerSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-content: center;
  border-bottom: 1px solid ${colors.grayBorderLight};
  width: 100%;
  padding: 10px;
`

export default InvoiceDetails
